import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ScrollImage } from './ScrollImage';
import { ShieldCheck, Zap } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden bg-slate-900 min-h-screen flex items-center py-8 lg:py-10" data-id="element-94">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10" data-id="element-95">
        <div className="absolute -top-24 -left-24 h-96 w-96 rounded-full bg-emerald-500 blur-3xl" data-id="element-96"></div>
        <div className="absolute top-1/2 right-0 h-96 w-96 -translate-y-1/2 rounded-full bg-blue-500 blur-3xl" data-id="element-97"></div>
      </div>

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-98">
        <div className="mx-auto max-w-4xl text-center" data-id="element-99">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-100">
            <h1 className="mb-6 text-3xl leading-tight text-white sm:text-4xl md:text-5xl lg:text-[3.25rem] font-display" data-id="element-101">
              ORGANIZA TODA TU TEMPORADA DE SESIONES DE{' '}
              <span className="text-emerald-400" data-id="element-102">PSICOLOGÍA DEPORTIVA</span> HOY
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-103">
            <div className="mb-6 flex justify-center" data-id="element-104">
              <ScrollImage src="https://cdn.magicpatterns.com/uploads/2fusPuyD529iw7oHCdFpMC/Diseno_sin_titulo_(24).png" alt="KIT Psicólogo Deportivo" className="w-full max-w-sm md:max-w-md drop-shadow-2xl" data-id="element-105" />
            </div>

            <div className="flex flex-col items-center gap-4" data-id="element-106">
              <Button className="w-full max-w-md text-lg sm:text-xl py-5" data-id="element-107">
                SÍ, QUIERO EL KIT AHORA
              </Button>

              <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-slate-300" data-id="element-108">
                <div className="flex items-center gap-2" data-id="element-109">
                  <Zap className="h-5 w-5 text-emerald-400" data-id="element-110" />
                  <span data-id="element-111">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-112">
                  <ShieldCheck className="h-5 w-5 text-emerald-400" data-id="element-113" />
                  <span data-id="element-114">Pago único y seguro</span>
                </div>
              </div>

              <p className="text-base sm:text-lg font-semibold text-emerald-400" data-id="element-115">
                Descargás. Aplicás. Trabajás con más seguridad profesional.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}